import styled from 'styled-components'
import {InputText} from '@components/commons/input-text/InputText.tsx'

export const StyledInputText = styled(InputText)`
    width: 180px;
`
